<script>
import resources from './resources'

export default {
  name: 'gadget-abstract-specialty',
  mixins: [resources]
}
</script>

<template lang="pug">
  section.gadget-resumo-especialidade.white-bg.wrapper.half-width.gadget
    .gadget-title
      | Resumo por Especilidades
    .actions
      span.icon 
      ul
        li.exclude Remover
        li.half-width Lado a Lado
        li.full-width Tela Inteira
    div
      .col-xs-12.col-sm-6
        label.light-red Mês de Referência
        h3.medium-gray Junho de 2017
      .col-xs-12.col-sm-6
        label.light-red Total de Eventos
        h3.medium-gray {{ total }}
    div(style='margin-top:15px')
      .col-xs-12
        label.light-red Eventos por Especilidade
      .table.col-xs-12
        .row.hidden-xs.hidden-sm
          .col-xs-12.col-sm-7.col-title.active Especialidade
          .col-xs-12.col-sm-5.col-title.text-center Eventos
        .order-by.hidden-md.hidden-lg
          | Ordenar por
          span
            select#ordenar-por(name='Ordenar por')
              option(value='Especialidade') Especialidade
              option(value='Eventos') Eventos
        ul.row
          li(v-for="speciality in statistics", :key="speciality.id")
            .col-xs-12.col-sm-7
              small.grey
                | Especialidade
                br
              | {{ speciality.speciality }}
            .col-xs-12.col-sm-5.text-center
              small.grey
                | Eventos
                br
              | {{ speciality.total }}
            .clearfix
</template>



// WEBPACK FOOTER //
// src/app/team/dashboard/gadget/components/abstract-speciality/abstract-speciality.vue